module.exports = __webpack_public_path__ + "img/IOP.29df70ab.svg";